// API base URL — read from env at build time.
// Create a `.env.development` file with REACT_APP_API_BASE_URL=http://127.0.0.1:8000/api/v1
const FALLBACK = "http://127.0.0.1:8000/api/v1";

export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || FALLBACK;

export const TOKEN_STORAGE_KEY = "phm_token";
export const REFRESH_TOKEN_STORAGE_KEY = "phm_refresh_token";
